export const FETCH_SURVEY_RESULTS_REQUEST = 'FETCH_SURVEY_RESULTS_REQUEST';
export const FETCH_SURVEY_RESULTS_SUCCESS = 'FETCH_SURVEY_RESULTS_SUCCESS';
export const FETCH_SURVEY_RESULTS_FAILURE = 'FETCH_SURVEY_RESULTS_FAILURE';

export const FETCH_SURVEY_INFO_REQUEST = 'FETCH_SURVEY_INFO_REQUEST';
export const FETCH_SURVEY_INFO_SUCCESS = 'FETCH_SURVEY_INFO_SUCCESS';
export const FETCH_SURVEY_INFO_FAILURE = 'FETCH_SURVEY_INFO_FAILURE';